export default __webpack_public_path__ + "static/media/ALLERGEN_CRUSTACEANS.8bae9150.png";